/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { cardIssuingGetFull } from "../../funcs/cardIssuingGetFull.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetFullIssuedCardRequest$inboundSchema,
};

export const tool$cardIssuingGetFull: ToolDefinition<typeof args> = {
  name: "card-issuing-get-full",
  description: `Get issued card with PAN, CVV, and expiration. 

Only use this endpoint if you have provided Moov with a copy of your PCI attestation of compliance.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/issued-cards.read-secure\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await cardIssuingGetFull(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
